import { getApps } from 'firebase/app';
import type { AppCheck } from 'firebase/app-check';

/**
 * App Check is initialised as a side effect of importing `firebase.ts`. This
 * module hands back the instance without creating an import cycle between the
 * API client and the Firebase bootstrap.
 */
let instance: AppCheck | null = null;

export function setAppCheck(appCheck: AppCheck): void {
  instance = appCheck;
}

export function getAppCheck(): AppCheck | null {
  // Guard against being called before Firebase has been bootstrapped at all.
  if (!getApps().length) return null;
  return instance;
}
